import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import documentUploadMixin from '@/mixins/documentUpload';
import { formMixin, validators } from '@/components/forms/mixin';
import getValidationMessage from '@/helpers/getValidationMessage';
import { isNumber } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/app-modals';
import promoCodeMixin from '@/mixins/promoCode';
import depositWarningMixin from '@/mixins/depositWarningMixin';

const AMOUNT_STEP_ONE = 10;
const AMOUNT_STEP_THREE = 50;
const AMOUNT_STEP_FOUR = 100;

export default {
  mixins: [
    documentUploadMixin,
    formMixin,
    loaderMixin,
    promoCodeMixin,
    depositWarningMixin
  ],
  data() {
    return {
      error: null,
      canDeposit: false,
      isReady: false,
      disclaimer: '',
      fields: {
        amount: '',
      },
      depositAmounts: [
        AMOUNT_STEP_ONE,
        AMOUNT_STEP_THREE,
        AMOUNT_STEP_FOUR,
      ],
    };
  },
  validations() {
    return {
      fields: {
        amount: validators.depositAmountCoinbase(
          this.minimumDepositAmount, this.maximumDepositAmount),
      },
    };
  },
  methods: {
    ...mapActions('wallet', ['getDepositUSDCoin']),
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentPopupOptions']),
    handleAmountBlur() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'fill',
        label: 'Amount',
      });
    },
    onUpdateAmount(amount) {
      if (this.fields.amount === '') {
        this.fields.amount = amount;
      } else if (isNumber(this.fields.amount)) {
        this.fields.amount = Number(this.fields.amount) + amount;
      }
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: `Amount ${amount} Button`,
      });
    },
    onSubmit() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit Confirm',
        action: 'submit',
        label: 'Confirm Deposit',
      });
      this.setCurrentPopup(MODALS.COINBASE);
      this.setCurrentPopupOptions({ depositPayload: this.depositPayload });
    },
  },
  computed: {
    ...mapState('wallet', ['depositMethods']),
    minimumDepositAmount() {
      return this.depositMethods.minimumDepositAmount || 10.0;
    },
    maximumDepositAmount() {
      return 99999;
    },
    depositPayload() {
      return {
        amount: this.fields.amount,
        depositPromoCode: '',
        marketingSource: '',
        marketingProgram: '',
      };
    },
    amountHasError() {
      return this.$v.fields.amount.$error;
    },
    amountValidationMessage() {
      return getValidationMessage(this.$v.fields.amount);
    },
    isConfirmDisabled() {
      return this.invalidOrDisabled || !this.canDeposit;
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getDepositUSDCoin()
    .then((data) => {
      this.checkDocumentUploadFlags(data);
      this.loaderRemove(document.body);
      this.promoCodeDetail = data.promoCodeDetail || {};
      this.canDeposit = data.canDeposit;
      this.disclaimer = data.disclaimer;
      this.isReady = true;
    })
    .catch((error) => {
      this.isReady = true;
      this.error = get(error, 'response.data.message', null);
      this.loaderRemove(document.body);
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-coinbase/add-funds-coinbase.js